import { render, staticRenderFns } from "./MessagesList.vue?vue&type=template&id=56915f64&scoped=true&"
import script from "./MessagesList.vue?vue&type=script&lang=js&"
export * from "./MessagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56915f64",
  null
  
)

export default component.exports